<template>
  <div>
    <Card shadow :padding="15">
      <Row type="flex" align="middle">
        <i-col :span="24">
          <div @click="isShow = !isShow">
            <Row type="flex" align="middle">
              <i-col :span="3" style="text-align:center">
                <Icon :type="icon" size="35"></Icon></i-col>
              <i-col :span="19">
                <p class="section-header">{{title}}</p>
                <span class="section-label">{{info}}</span>
              </i-col>
              <i-col :span="2"><Icon :type="(isShow) ? 'chevron-up':'chevron-down'" style=""></Icon></i-col>
            </Row>
          </div>
        </i-col>
          <i-col :span="24">
            <div style="height:auto;overflow:hidden">
              <transition
                  mode="out-in"
                  enter-active-class="animated slideInDown faster"
                  leave-active-class="animated slideOutUp faster">
                <div v-show="isShow">
                  <UserProfileSettingField :hide-check="hideCheck" :profile="profile" :slug="fieldslugs" :tooltips="tooltips">
                  </UserProfileSettingField>
                </div>
              </transition>
            </div>
          </i-col>
      </Row>
    </Card>
  </div>
</template>

<script>
import UserProfileSettingField from '@/views/UserProfileSettingFieldComponent'

export default {
  components: {
    UserProfileSettingField
  },
  props: {
    hideCheck: {
      type:Boolean
    },
    tag: {
      type: String
    },
    icon: {
      type: String
    },
    title: {
      type: String
    },
    info: {
      type: String
    },
    fieldslugs: {
      type: Array
    },
    profile: {
      type: Object
    },
    tooltips: {
      type: Array
    }
  },
  data() {
    return {
      collapse: false
    }
  },
  computed: {
    isShow: {
      get() { return this.collapse },
      set(v) { this.collapse = v }
    }
  },
  methods: {
    init(){
      console.log('test')
    }
  }
}
</script>

<style scoped>
  .add-margin {
    margin-bottom:5px;
  }
  .section-header {
    font-weight: 700;
    color:#333;
  }
  .section-label {
    font-size:11px;
    line-height: 20px;
    color:#aaa;
  }
  .section-value {
    min-height: 20px;
    display: block;
  }
  .m {
    color: #333
  }
</style>
